import { HttpStatusCode } from 'axios';
import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { VendorBusinessLocation } from '../../../../../types/dbTypes';
import useApi from '../../../../../utils/AxiosWrapper';
import { useUser } from '../../../../../utils/UserContext';
import CreatePromotion from './CreatePromotion';
import EditPromotion from './EditPromotion';
import VendorPromotionsList from './VendorPromotionsList';

interface VendorPromotionsProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function VendorPromotions({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: VendorPromotionsProps) {
  const [loadingLocations, setLoadingLocations] = useState<boolean>(false);
  const [businessLocations, setBusinessLocations] = useState<
    VendorBusinessLocation[]
  >([]);
  const { userId } = useUser();
  const { callProtectedApi } = useApi();

  useEffect(() => {
    const fetchBusinessLocationsForVendor = async (vendor_id: string) => {
      setLoadingLocations(true);
      try {
        const response = await callProtectedApi(
          `/vendorBusinessLocations/list/${vendor_id}`,
          'get',
          {},
          'Error occurred while fetching your business locations.'
        );
        const data = response?.data?.data?.vendorBusinessLocations;
        if (
          data &&
          data?.length > 0 &&
          response?.status === HttpStatusCode.Ok
        ) {
          setBusinessLocations(data);
        }
      } catch (e: any) {
        console.error(
          'Error occurred while fetching your vendor business locations: ',
          e
        );
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchBusinessLocationsForVendor(userId ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };
  return (
    <Routes>
      <Route
        path="/"
        element={
          <VendorPromotionsList
            loadingLocations={loadingLocations}
            businessLocations={businessLocations}
            {...props}
          />
        }
      />
      <Route
        path="create"
        element={<CreatePromotion locations={businessLocations} {...props} />}
      />
      <Route
        path="edit/:deal_id"
        element={<EditPromotion locations={businessLocations} {...props} />}
      />
    </Routes>
  );
}

export default VendorPromotions;
